import reducers from './modules/reducers';

export default reducers;